module.exports = __webpack_public_path__ + "static/media/js.9f0a24d5.png";